import { graphqlApi } from '..'

import { gql } from 'graphql-request'

export const adminGQL = graphqlApi.injectEndpoints({
  endpoints: (builder) => ({
    getMessageTemplateList: builder.query<any, { isActive?: boolean; query?: string }>({
      query: ({ isActive, query }) => ({
        document: gql`
          query GetMessageTemplates($query: String, $isActive: Boolean) {
            allMessageTemplates(
              filters: {
                OR: { name: { iContains: $query } }
                body: { iContains: $query }
                isActive: $isActive
              }
              order: { name: ASC }
            ) {
              createdAt
              modifiedAt
              id
              name
              body
              isActive
              pk
            }
          }
        `,
        variables: { isActive, query },
      }),
      providesTags: ['gql:customerMsgTemplates'],
    }),

    createMessageTemplate: builder.mutation<
      unknown,
      {
        name: string
        body: string
        isActive: boolean
      }
    >({
      query: ({ name, body, isActive }) => ({
        document: gql`
          mutation CreateMessageTemplate($name: String!, $body: String!, $isActive: Boolean) {
            messageTemplateCreate(data: { name: $name, body: $body, isActive: $isActive }) {
              name
              body
              isActive
            }
          }
        `,
        variables: { name, body, isActive },
      }),
      invalidatesTags: ['gql:customerMsgTemplates'],
    }),

    updateMessageTemplate: builder.mutation<
      unknown,
      {
        pk: string
        name: string
        body: string
        isActive: boolean
      }
    >({
      query: ({ pk, name, body, isActive }) => ({
        document: gql`
          mutation UpdateMessageTemplate(
            $pk: ID!
            $name: String
            $body: String
            $isActive: Boolean
          ) {
            messageTemplateUpdate(
              data: { pk: $pk, name: $name, body: $body, isActive: $isActive }
            ) {
              ... on MessageTemplate {
                pk
                name
                body
                isActive
              }
            }
          }
        `,
        variables: { pk, name, body, isActive },
      }),
      invalidatesTags: ['gql:customerMsgTemplates'],
    }),

    deleteMessageTemplate: builder.mutation<unknown, string>({
      query: (id) => ({
        document: gql`
          mutation DeleteMessageTemplate($pk: ID!) {
            messageTemplateDelete(data: { pk: $pk }) {
              ... on MessageTemplate {
                pk
              }
            }
          }
        `,
        variables: { pk: id },
      }),
      invalidatesTags: ['gql:customerMsgTemplates'],
    }),
  }),
})

export const {
  useGetMessageTemplateListQuery,
  useCreateMessageTemplateMutation,
  useUpdateMessageTemplateMutation,
  useDeleteMessageTemplateMutation,
} = adminGQL
